import { isAxiosError } from "axios";
import i18n, { t } from "i18next";
import axios from "../lib/axios";

export async function deleteAward(id: number) {
  try {
    const response = await axios.put(`/api/awards-delete`, null, {
      headers: {
        "Accept-Language": i18n.language,
      },
      params: {
        id,
      },
    });

    return {
      isOk: true,
      message: response.data.message || t("Award deleted succesfull!"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function updateAward(id: number, confirmed: number) {
  try {
    const response = await axios.put(
      `/api/awards?id=${id}&confirmed=${confirmed}`,
      undefined,
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      message: response.data.message || t("Award updated successfully."),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function fetchAwards(companyId: number, from?: Date, to?: Date, includeApproved?: boolean) {
  try {
    const response = await axios.get(`/api/awards`, {
      params: {
        companyId,
        from,
        to,
        includeApproved,
      },
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      message:
        response.data.message ||
        t("Information download completed successfully"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function fetchAwardsSummary(
  companyId: number,
  projectId?: number,
  month?: string,
) {
  try {
    const response = await axios.get(`/api/awards-summary`, {
      params: { companyId, projectId, month },
      headers: { "Accept-Language": i18n.language },
    });

    return {
      isOk: true,
      data: response.data,
      message: t("Award summary retrieved successfully."),
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function createAward(
  employeeId: number[],
  companyId: number[],
  month: string,
  sum: number,
  awardType: string,
  projectId: number,
  confirmed: number,
  note?: string,
) {
  try {
    const response = await axios.post(
      `/api/awards`,
      {
        employeeId,
        companyId,
        month,
        sum,
        awardType,
        projectId,
        confirmed,
        note,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      message: response.data.message || t("Award created successfully."),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}
